var publicPath = __webpack_public_path__;
                    var symbolUrl = 'sprites.d60235ac34151caba27e9619ca18f7e1.svg#r';
                    var viewUrl = 'sprites.d60235ac34151caba27e9619ca18f7e1.svg#view-r';

                    

                    module.exports = {
                        url: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 25 24',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };